const dev =
  window.location.hostname == "localhost" ||
  localStorage.developmentMode ||
  window.navigator.userAgent.substr(window.navigator.userAgent.length - 3) ===
    "app"
    ? true
    : false;

import moment from "moment";

import * as Sentry from "@sentry/vue";

export default (message, color, data, send_setry) => {
  if (send_setry) {
    const scope = new Sentry.Scope();
    scope.user = { user: data.username };
    scope.setExtra("data", data.data);
    scope.setExtra("error_response", data.error_response);

    Sentry.captureException(
      new Error(data.data.username + " -> " + message),
      scope
    );
  }
  color || "black";
  const time = "TIME -> " + moment().format("DD-MM-YYYY HH:mm:ss:ms") + " -> ";
  let type = "DEBUG -> ";
  switch (color) {
    case "success":
      type += "SUCCESS: ";
      color = "greenyellow";
      break;
    case "info":
      type += "INFO: ";
      color = "dodgerBlue";
      break;
    case "error":
      color = "red";
      type += "ERROR: ";
      break;
    case "warning":
      color = "orange";
      type += "WARNING ";
      break;
    case "ya_metric":
      type += "YA_METRIC ";
      color = "#F16C06";
      break;
  }
  if (dev) {
    localStorage.setItem("debug", "cornerstoneTools");
    console.log(
      "%c" + type + time + message,
      "color:" + color,
      data ? data : ""
    );
  }
};
